import '.an{position:relative;}.ssr-plugin'
import '.iw{width:64px;}.ssr-plugin'
import '.ix{height:64px;}.ssr-plugin'
import '.ah{flex-shrink:0;}.ssr-plugin'
import '.by{position:absolute;}.ssr-plugin'
import '.iy{bottom:-4px;}.ssr-plugin'
import '.hv{right:-4px;}.ssr-plugin'
import '.fr{border-radius:50%;}.ssr-plugin'
import '.iz{border:2px solid var(--palette-white);}.ssr-plugin'
import '.az{overflow:hidden;}.ssr-plugin'
import '.j0{width:32px;}.ssr-plugin'
import '.j1{height:32px;}.ssr-plugin'
import { styled } from 'inlines'
import { Avatar } from '@app/components/core/avatar/Avatar'
import { Image } from '@app/components/core/image/Image'

type ConversationAvatarProps = {
  initiativeImage?: string
  userAvatar?: string
  userName: string
}

export const ConversationAvatar = ({
  initiativeImage,
  userAvatar,
  userName,
}: ConversationAvatarProps) => {
  return (
    <div className="an iw ix ah"
    >
      {initiativeImage ? (
        <Image
          src={initiativeImage}
          resizeWidth={128}
          alt="initiative"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: '12px',
          }}
        />
      ) : (
        <Avatar
          size="medium"
          shape="square"
          labelSource={userName}
          variant="yellow"
        />
      )}
      <div className="by iy hv fr iz az j0 j1"
      >
        <Avatar
          size="extra-small"
          shape="circle"
          image={userAvatar}
          labelSource={userName}
        />
      </div>
    </div>
  )
}
